import { render, staticRenderFns } from "./mobile-validate-dialog.vue?vue&type=template&id=23a8b03f&scoped=true&"
import script from "./mobile-validate-dialog.vue?vue&type=script&lang=js&"
export * from "./mobile-validate-dialog.vue?vue&type=script&lang=js&"
import style0 from "./mobile-validate-dialog.vue?vue&type=style&index=0&id=23a8b03f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a8b03f",
  null
  
)

export default component.exports